import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import Paginator from '@/components/v2/Paginator.vue';
import ShowcaseProducts from '@/plugins/graphql/queries/your_store/showcase-products.gql';
import DeleteAffiliateProduct from '@/plugins/graphql/mutations/v2/your_store/delete-affiliate-product.gql';
import { EcommerceProductModel } from '@/helpers/entities/models/EcommerceProductModel';
import Products from './Products.vue';
let ProductShowcaseCatalog = class ProductShowcaseCatalog extends Mixins(PaginatorMixin) {
    async remove(event) {
        const vm = this;
        await vm.$apollo.mutate({
            mutation: DeleteAffiliateProduct,
            variables: {
                input: {
                    appUuid: vm.appUUID,
                    productUuid: event.uuid,
                },
            },
        });
        await vm.fetchProducts();
    }
    async handleFilterByProductName(name) {
        const vm = this;
        vm.filterByProductName = name;
        vm.startCursor = null;
        await vm.fetchProducts();
    }
    async fetchProducts() {
        await this.$apollo.queries.products.refetch();
    }
};
__decorate([
    Prop({ type: String, required: true })
], ProductShowcaseCatalog.prototype, "appUUID", void 0);
ProductShowcaseCatalog = __decorate([
    Component({
        apollo: {
            products: {
                query: ShowcaseProducts,
                fetchPolicy: 'network-only',
                variables() {
                    return {
                        appUUID: this.appUUID,
                        first: this.perPage,
                        after: this.startCursor,
                        productName: this.filterByProductName,
                    };
                },
                update(data) {
                    const { edges, pageInfo, totalCount } = data.fetchShowcaseProducts;
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map((product) => new EcommerceProductModel(product.node));
                },
            },
        },
        components: {
            PageTitle,
            Products,
            Paginator,
        },
        data() {
            return {
                filterByProductName: '',
            };
        },
        async mounted() {
            await this.fetchProducts();
        },
    })
], ProductShowcaseCatalog);
export default ProductShowcaseCatalog;
